import { requests } from "../../../services/external/APIs"
import { PreliquidationHourSummaryRequest } from "../models/requests"

const API_URL = '/dublin/api'

export const modifyOvertimeHours = async (id: number, model: PreliquidationHourSummaryRequest) => 
    requests.put(`${API_URL}/v1/liquidate/hours/${id}`, model);